export const environment = {
  production: false,
  type: 'dev',
  title: 'AumYe 1.2 Development',
  apiUrl: 'https://aumyedevportal.azurewebsites.net/api/',
  googleMapsApiKey: 'AIzaSyCQSAPyJAtLpIfNx-6oyXpn270bS0hVP18',
  MONITORING_INTERVAL: 15000,
  encryptionKey: '@123Aum!@34)93jdm+sd.//@#@$5suheYe-Sachin///Raj',
  firebaseConfig: {
    apiKey: 'AIzaSyB_rfNotGeAeLOcQPGy6w5_eZL7wE62v74',
    authDomain: 'aumye-877d3.firebaseapp.com',
    projectId: 'aumye-877d3',
    databaseURL:
      'https://aumye-877d3-default-rtdb.asia-southeast1.firebasedatabase.app',
    storageBucket: 'aumye-877d3.appspot.com',
    messagingSenderId: '32394336590',
    appId: '1:32394336590:web:ef7cdcfbe68fb32e426567',
    measurementId: 'G-6RF301HVPJ',
    vpaidkey:
      'BH7lNNj21caezJMAse-ZdQQwM2XfKvJgTxm5f0qrptKgJAL1y0gKPNLFepgRDv49XJHHD6skI5aHBQAtaS1mADQ',
  },
  printerAllowed: [
    '818e513c-56e5-438a-b34a-d44f050e9666',
    '19acb5c7-b1b9-4a62-9f22-9cb0c9ca1723',
  ],
  AllowdPrinterIP: {
    '818e513c-56e5-438a-b34a-d44f050e9666': '10.200.40.222',
    '7cf3b37d-2605-47ca-9876-30617369260d': '192.168.2.105',
  },
};
